import {createSagaAction} from "utils";

import {NAME} from './constants';

const SEARCH_MANIFESTS = `${NAME}/SEARCH_MANIFESTS`;
const NEXT_MANIFEST_PAGE = `${NAME}/NEXT_MANIFEST_PAGE`;

export const searchManifests = createSagaAction(SEARCH_MANIFESTS);
export const getNextManifestPage = createSagaAction(NEXT_MANIFEST_PAGE);
